import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "footer-content" }
const _hoisted_3 = { class: "footer-links" }
const _hoisted_4 = { class: "copyright" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, { to: "/privacy-policy" }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode("Privacy Policy")
          ])),
          _: 1
        }),
        _cache[2] || (_cache[2] = _createTextVNode(" | ")),
        _createVNode(_component_router_link, { to: "/terms-of-service" }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode("Terms of Service")
          ])),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, " © " + _toDisplayString(_ctx.currentYear) + " Studio 308 LLC. All rights reserved. ", 1)
    ])
  ]))
}